"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bannerItemStyles = exports.Root = exports.PrimaryAddressMessage = exports.PickupShippingOffer = exports.PickupHintMessage = exports.Indicator = exports.DeliveryMessage = exports.ConfirmButtonArea = exports.CheckHeavyIcon = exports.AddressBoxWrapper = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _HintMessage = require("../HintMessage");
var _ShippingOffer = require("./ShippingOffer");
const Root = exports.Root = (0, _mui.styled)('div')(({
  ownerState: {
    isActive,
    isInvalid,
    isDisplayedInMainPage,
    isShownOnMap
  },
  theme
}) => ({
  position: 'relative',
  display: 'block',
  borderRadius: theme.shape.largeComponentRadius,
  cursor: 'pointer',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.default.main,
  boxShadow: 'none',
  marginBottom: theme.spacing(4),
  transition: 'box-shadow 300ms, border-color 300ms',
  ...(isInvalid && {
    paddingTop: 23
  }),
  ...((Boolean(isInvalid) || Boolean(isDisplayedInMainPage) || Boolean(isShownOnMap)) && {
    cursor: 'default'
  }),
  ...(isActive && {
    border: `1px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows[3]
  }),
  ...(!isActive && !isInvalid && {
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        border: `1px solid ${theme.palette.background.paper}`,
        boxShadow: theme.shadows[3]
      }
    }
  })
}));
const Indicator = exports.Indicator = (0, _mui.styled)('div')(({
  ownerState: {
    isActive
  },
  theme
}) => ({
  position: 'absolute',
  top: -1,
  left: -1,
  width: 50,
  height: 50,
  overflow: 'hidden',
  opacity: 0,
  borderTopLeftRadius: theme.shape.largeComponentRadius,
  transition: theme.transitions.create('opacity'),
  '&::before': {
    position: 'absolute',
    top: 0,
    left: 0,
    content: '""',
    transform: 'translate(-50%, -50%) rotate(45deg)',
    width: 50,
    height: 50,
    zIndex: 0,
    background: theme.palette.primary.main
  },
  ...(isActive && {
    opacity: 1
  })
}));
const CheckHeavyIcon = exports.CheckHeavyIcon = (0, _mui.styled)(_icons.CheckHeavy)(({
  theme
}) => ({
  position: 'relative',
  left: 1,
  top: 1,
  fontSize: '2rem',
  color: theme.palette.text.primary
}));
const AddressBoxWrapper = exports.AddressBoxWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isFilteredHomeAddress,
    isInvalid
  },
  theme
}) => ({
  padding: theme.spacing(4, 3, 0, 3),
  ...((Boolean(isInvalid) || isFilteredHomeAddress) && {
    paddingBottom: theme.spacing(4)
  }),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 4, 0, 4),
    ...((Boolean(isInvalid) || isFilteredHomeAddress) && {
      paddingBottom: theme.spacing(4)
    })
  }
}));
const DeliveryMessage = exports.DeliveryMessage = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  textAlign: 'center',
  borderRadius: theme.spacing(2, 2, 0, 0),
  padding: theme.spacing(1, 0),
  color: theme.palette.error.dark,
  fontWeight: 'bold',
  lineHeight: 1.3,
  textTransform: 'uppercase',
  background: (0, _mui.alpha)(theme.palette.error.main, 0.1)
}));
const PrimaryAddressMessage = exports.PrimaryAddressMessage = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  position: 'relative',
  left: 0,
  bottom: 0,
  display: 'block',
  width: '100%',
  textAlign: 'center',
  borderRadius: theme.spacing(0, 0, 2, 2),
  padding: theme.spacing(1, 0),
  color: theme.palette.grey[700],
  fontWeight: 'bold',
  lineHeight: 1.3,
  textTransform: 'uppercase',
  background: theme.palette.grey[100]
}));
const bannerItemStyles = ({
  theme
}) => ({
  margin: theme.spacing(2, 3),
  width: 'auto'
});
exports.bannerItemStyles = bannerItemStyles;
const PickupShippingOffer = exports.PickupShippingOffer = (0, _mui.styled)(_ShippingOffer.ShippingOffer)(bannerItemStyles);
const PickupHintMessage = exports.PickupHintMessage = (0, _mui.styled)(_HintMessage.HintMessage)(bannerItemStyles);
const ConfirmButtonArea = exports.ConfirmButtonArea = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(4)
}));